module.exports=require("./_global").document&&document.documentElement;